<script setup lang="ts">
import { InputPrimary } from '@shared/ui/input'

import { useTutorApplicationStore } from '../../model/store'
import { useFullName } from '../../model/personal-information/full-name.hooks'

defineOptions({
  name: 'InputFullName',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  mode,
  setFullName,
} = useFullName()

</script>

<template>
  <InputPrimary
    id="parent-first-name"
    name="parent_first_name"
    type="text"
    label="Full name"
    placeholder="Full name"
    :required="true"
    :value="tutorApplicationStore.fullName"
    :mode="mode"
    error-message="Please enter your full name"
    @input="setFullName"
  />
</template>
